module.exports = __webpack_public_path__ + "img/fileicon.11c3457d.svg";